import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    effect,
    EventEmitter,
    inject,
    Input,
    OnChanges,
    OnInit,
    Output,
    signal,
    SimpleChanges
} from '@angular/core';
import {CommonModule} from '@angular/common';
import {MatIcon} from '@angular/material/icon';
import {MatInput} from '@angular/material/input';
import {FormBuilder, FormControl, ReactiveFormsModule, Validators} from '@angular/forms';
import {map, startWith} from 'rxjs/operators';
import {distinctUntilChanged, filter, Observable} from 'rxjs';
import {AccessRoleDirective} from '../access-role.directive';
import {MatProgressSpinner} from '@angular/material/progress-spinner';
import {CurrentUserService} from '../../../../core/services/user.service';

@Component({
    selector: 'pas-grade-fill-form',
    standalone: true,
    imports: [MatIcon, MatInput, ReactiveFormsModule, CommonModule, AccessRoleDirective, MatProgressSpinner,],
    templateUrl: './grade-fill-form.component.html',
    styleUrl: './grade-fill-form.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class GradeFillFormComponent implements OnInit {

    currentUser = inject(CurrentUserService).user;

    public _object: ItemInGrade | null = null;
    public filtered$: Observable<IndexValue[] | undefined> | null = null;
    private initialFilledIndexNumber = signal<number>(0);
    _busy: boolean = false;

    cdr = inject(ChangeDetectorRef);

    @Input() set object(v: ItemInGrade | null) {
        if (typeof v !== 'object') return;
        this._object = v && {...v};
        this.form.get('search')!.setValue('');
        // this.currentIndex.set(null);
        this.initialFilledIndexNumber.set(this.filledValues)
    };


    @Input() stage: Stage = 'create';
    @Input() mode: 'view' | 'edit' = 'view';

    @Input() canUpload = false;
    @Input() uploading = false;

    @Input() set busy(v: boolean) {
        this._busy = v;
        // this.cdr.markForCheck();
        // this.cdr.detectChanges();
    }
    @Output() uploadExcel = new EventEmitter<File>();

    @Output() enterData = new EventEmitter();
    @Output() exportExcel = new EventEmitter();
    @Output() noViolations = new EventEmitter();

    currentIndex = signal<IndexValue | null>(null);
    currentOrderIndex = signal<number | null>(null);

    fb = inject(FormBuilder);

    form = this.fb.group({
        value: this.fb.control<any>(null, [Validators.required]),
        comment: this.fb.control(''),
        search: this.fb.control(''),
        valueItem: this.fb.control<number | undefined>(undefined),
    })

    withoutRemarks = new FormControl(false )

    get valueItem() {
        return this.form.get('valueItem')!.value;
    }

    get filledValues(): number {
        const res = this._object?.indexValues.filter((v: IndexValue) => v.value !== undefined && v.value !== null || v.valueItem).length || 0;
        this.enterData.emit(this.initialFilledIndexNumber() - res);
        return res;
    }


    get jsonObject(): string {
        return JSON.stringify(this.object, null, 2);
    }

    search(query: string | null): IndexValue[] {
        return this._object?.indexValues.filter(v =>
            (v.index.name + ' ' + v.index.shortName).toLowerCase().includes(query!.toLowerCase())) || []
    }

    ngOnInit() {
        //--- Поиск по индексу ---
        this.filtered$ = this.form.get('search')!.valueChanges
            .pipe(startWith(''))
            .pipe(map(v => this.search(v)));


        this.form.get('value')!.valueChanges.subscribe((v: any) => {
            console.log('value', v);
            if (!this.currentIndex()) return;
            this.currentIndex()!.value = v;
        })
        this.form.get('valueItem')!.valueChanges.pipe(
            distinctUntilChanged(),
            filter(v=>v!==undefined),
        ).subscribe((v) => {
            if (!this.currentIndex()) return;

            const foundIndexItem = this.currentIndex()?.index?.indexItems?.find(e => e.id === v)
            this.currentIndex()!.valueItem = foundIndexItem || null;
        })
        this.form.get('comment')!.valueChanges.subscribe((v: any) => {
            console.log('comment', v);
            if (!this.currentIndex()) return;
            this.currentIndex()!.comment = v;
        })

        this.form.valueChanges.subscribe((v: any) => {
            console.log('valueChanges form', v);
        })

        this.withoutRemarks.valueChanges.subscribe((v: any) => {
            console.log('withoutRemarks', v);
        })
    }

    private _effect = effect(() => {
        if (!this.currentIndex()) return;
        this.form.get('value')!.setValue(this.currentIndex()!.value);
        this.form.get('valueItem')!.setValue(this.currentIndex()!.valueItem?.id);
        this.form.get('comment')!.setValue(this.currentIndex()!.comment);
    })



    toString(value: any, property: string = 'name') {
        if (typeof value === 'object' && value !== null) return value[property];
        return value;
    }

    onExcelClick() {
        this.exportExcel.emit(this._object);
    }

    setIndex(f: IndexValue | null, orderIndex: number | null) {
        console.log(
            'currentIndex', f, 'orderIndex', orderIndex, 'currentIndex', this.currentIndex(), 'currentOrderIndex', this.currentOrderIndex
        )
        this.currentIndex.set(f)
        if (orderIndex === this.currentOrderIndex()) {
            this.currentOrderIndex.set(null)
        } else {
            this.currentOrderIndex.set(orderIndex)
        }
    }

    onChange(e: Event, i: any) {

        if (this.currentIndex()?.index.id === 55 && i.id === 214) {
            const index55 = this._object?.indexValues.findIndex(e => e.index.id === 55)
            const index56 = this._object?.indexValues.findIndex(e => e.index.id === 56)
            if (index56 === undefined || index55 === undefined) return;
            this.setIndex(this._object?.indexValues[index56]!, index56);
            this.currentIndex()!.valueItem = this._object?.indexValues[index56].index.indexItems?.find(e => e.id === 216) || null;
        }
    }

    onWithoutRemarksClick($event: Event) {
        $event.stopPropagation();
        this.noViolations.emit();
    }

    importFile(input: HTMLInputElement): void {
        if (!this.canUpload || this.uploading) return;
        input.click();
    }

    onFileDownload(event: Event): void {
        const input = event.target as HTMLInputElement;
        const file = input.files?.[0];

        input.value = '';

        if (!file || !this.canUpload || this.uploading) return;

        this.uploadExcel.emit(file);
    }

}


